import {KpiVisibilityFlag} from '@hconnect/common/types'
import {CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {PlantStatusKpisContainer, PROCESS_ENGINEER_KPI_TYPES} from '@widgets/kpis'
import {Link} from 'react-router'

type Props = {
  plantId: string
  plantStatusPageHref?: string
}

export const ProcessPlantStatusKpisContainer: React.FC<Props> = ({
  plantId,
  plantStatusPageHref
}) => {
  const cardContent = (
    <PlantStatusKpisContainer
      plantId={plantId}
      kpiVisibilityFlag={KpiVisibilityFlag.ProcessEngineerEntryPoint}
      kpiTypes={PROCESS_ENGINEER_KPI_TYPES}
    />
  )

  if (!plantStatusPageHref) {
    return cardContent
  }

  return (
    <CardLinkWrapper<typeof Link>
      to={plantStatusPageHref}
      component={Link}
      data-test-id="plant-status-kpis-card-link-to-performance-plant-status"
    >
      {cardContent}
    </CardLinkWrapper>
  )
}
